var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585786 1.25241C0.960859 0.87734 1.46957 0.666626 2 0.666626H7.33333C7.51014 0.666626 7.67971 0.736864 7.80474 0.861888L11.8047 4.86189C11.9298 4.98691 12 5.15648 12 5.33329V13.3333C12 13.8637 11.7893 14.3724 11.4142 14.7475C11.0391 15.1226 10.5304 15.3333 10 15.3333H2C1.46957 15.3333 0.960859 15.1226 0.585786 14.7475C0.210714 14.3724 0 13.8637 0 13.3333V2.66663C0 2.13619 0.210714 1.62749 0.585786 1.25241ZM2 1.99996C1.82319 1.99996 1.65362 2.0702 1.5286 2.19522C1.40357 2.32025 1.33333 2.48981 1.33333 2.66663V13.3333C1.33333 13.5101 1.40357 13.6797 1.5286 13.8047C1.65362 13.9297 1.82319 14 2 14H10C10.1768 14 10.3464 13.9297 10.4714 13.8047C10.5964 13.6797 10.6667 13.5101 10.6667 13.3333V5.99996H7.33333C6.96514 5.99996 6.66667 5.70148 6.66667 5.33329V1.99996H2ZM8 2.94277L9.72386 4.66663H8V2.94277ZM3.33333 9.99996C3.33333 9.63177 3.63181 9.33329 4 9.33329H8C8.36819 9.33329 8.66667 9.63177 8.66667 9.99996C8.66667 10.3681 8.36819 10.6666 8 10.6666H4C3.63181 10.6666 3.33333 10.3681 3.33333 9.99996Z",
    fill: "#858A97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.bfa71f6f.svg";
export { ForwardRef as ReactComponent };